const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },

      {
        component: "search-check-group",
        label: "",
        value: "half",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "상반기", value: "상반기" },
            { text: "하반기", value: "하반기" },
          ],
          selectMaxCount: 1,
          default: [],
        },
      },
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상자", "수료자", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    // 상반기 / 하반기
    if (search.half && search.half.length > 0) {
      conditions.push({ key: "header.half", operator: "=", value: search.half });
    }

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "연도",
        key: "header.year",
      },
      {
        name: "반기",
        key: "header.half",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "대상자",
        key: "body.대상자",
      },
      {
        name: "수료자",
        key: "body.수료자",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const header = JSON.parse(value.post_content).header;
      switch (index) {
        case 0:
          return header.year; // 연도
        case 1:
          return header.half; // 반기
        case 2:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 3:
          return func.comma(func.getContent(value).대상자); // 대상자
        case 4:
          return func.comma(func.getContent(value).수료자); // 수료자
        case 5:
          return func.getContent(value).stdInfo.section; // 부서명
        case 6:
          return func.getContent(value).stdInfo.department; // 소속명
        case 7:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
};
export default list;
